import React from 'react';
import './About.css';
import Ribbons from '../../components/ReactBits/ribbon_cursor';

const About = () => {
  return (
    
    <div className="about-container">
      <div style={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100vw', 
        height: '100vh', 
        zIndex: 0, 
        overflow: 'hidden'
      }}>
        <Ribbons
          baseThickness={6}
          colors={['#ffffff']}
          speedMultiplier={0.5}
          maxAge={500}
          enableFade={true}
          enableShaderEffect={true}
        />
      </div>
      <div className="about-hero">
        <h1 className="about-title">Your Success Is Our Purpose</h1>
        <p className="about-subtitle">
          Skript empowers businesses with tailored digital solutions. From websites to mobile apps, desktop software, and AI-powered tools — we build it all, fast, smart, and scalable.
        </p>
      </div>

      <div className="about-section">
        <h2 className="section-heading">Our Mission</h2>
        <p>
          We turn your ideas into fully-deployed, production-ready solutions with ease. From the first line of code to live deployment, we handle the entire process — ensuring speed, precision, and reliability. Whether it's web apps, mobile apps, or custom software, we deploy seamlessly to cloud platforms, tailored hosting, or your own infrastructure.
        </p>
      </div>

      <div className="about-section">
        <h2 className="section-heading">What We Build</h2>
        <div className="services-grid">
          <div className="service-item">
            <h3>Custom Software Solutions</h3>
            <p>From concept to deployment, we build custom software that streamlines operations and drives growth.</p>
          </div>
          <div className="service-item">
            <h3>Mobile Applications</h3>
            <p>High-quality mobile apps with seamless user experiences on both Android and iOS platforms.</p>
          </div>
          <div className="service-item">
            <h3>Web Development</h3>
            <p>Responsive, scalable websites and web applications that engage visitors and enhance online presence.</p>
          </div>
          <div className="service-item">
            <h3>AI-Powered Tools</h3>
            <p>Intelligent solutions including automated quotation systems and smart business applications.</p>
          </div>
        </div>
      </div>

      <div className="about-section">
        <h2 className="section-heading">Our Products</h2>
        <div className="products-grid">
          <div className="product-item">
            <h3>Profit Pulse</h3>
            <p>Ultimate mobile POS solution for inventory management, invoice creation, and business reporting.</p>
          </div>
          <div className="product-item">
            <h3>BDesign</h3>
            <p>Efficient inventory management system with real-time stock control and data export capabilities.</p>
          </div>
          <div className="product-item">
            <h3>Shopify Accounting System</h3>
            <p>Comprehensive financial tracking and statement generation for Shopify store owners.</p>
          </div>
          <div className="product-item">
            <h3>IVisa Service</h3>
            <p>Travel agency management system for visa requirements and investment program tracking.</p>
          </div>
        </div>
      </div>

      {/* <div className="about-section">
        <h2 className="section-heading">Trusted by Industry Leaders</h2>
        <div className="partner-logos">
          <div className="logo">🏢 BAU</div>
          <div className="logo">📱 UAE</div>
          <div className="logo">🛒 Shopify</div>
          <div className="logo">🚀 Startups</div>
        </div>
      </div> */}

      {/* <div className="about-section quote-section">
        <h2 className="section-heading">Get a Free AI-Generated Quote</h2>
        <p>Submit your idea and let our AI system draft a tailored project quotation for you — fully editable and sent directly to your inbox and our team.</p>
        <button className="quote-button" onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Project Quotation
        </button>
      </div> */}
    </div>
  );
};

export default About;
